import { GenericService } from "../GenericService";

class UserGuestsService extends GenericService {
  constructor() {
    super("/api/guests");
  }

  getSingleRecord = (id) => this.get("/api/admin/question/single/" + id);
  getCompanyQuestions = (data) =>
    this.post("/api/admin/question/getCompanyQuestions", data);
  markAsFirst = (data) => this.post("/api/admin/question/markAsFirst", data);
  addCustomer = (data) => this.post("/api/guests/addFR", data);
}

export default new UserGuestsService();
